// @flow

// ExperimentOverlay is what an Experiment component is wrapped in when it is
// highlighted via the experiment debugger.

import React, { type Node } from 'react';
import { Box } from 'gestalt';

const ACTIVATED_COLOR = '#0f0';
const NOT_ACTIVATED_COLOR = '#00f';
const NOT_ELIGIBLE_COLOR = '#999';

type Props = {|
  children: Node,
  group: string,
  isEligible?: boolean,
  name: string,
  performsActivate?: boolean,
|};

export default function ExperimentOverlay({
  children,
  group,
  isEligible,
  name,
  performsActivate,
}: Props) {
  let color = performsActivate ? ACTIVATED_COLOR : NOT_ACTIVATED_COLOR;
  if (!isEligible) {
    color = NOT_ELIGIBLE_COLOR;
  }
  return (
    <Box position="relative">
      {children}
      <Box
        position="absolute"
        top
        bottom
        left
        right
        dangerouslySetInlineStyle={{
          __style: { boxShadow: `0 0 2px 2px ${color}`, borderRadius: 5 },
        }}
      />
      <Box position="absolute" top left color="lightGray">
        {name}: {group}
      </Box>
    </Box>
  );
}
